function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconLoyalty = function SvgIconLoyalty(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: props.color,
    d: "M20.99 9.25a1.5 1.5 0 0 1 0 1.5l-3.846 6.66a1.5 1.5 0 0 1-1.299.75h-7.69a1.5 1.5 0 0 1-1.3-.75L3.01 10.75a1.5 1.5 0 0 1 0-1.5l3.846-6.66a1.5 1.5 0 0 1 1.299-.75h7.69a1.5 1.5 0 0 1 1.3.75l3.845 6.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: props.color,
    strokeLinecap: "round",
    d: "M12 22.5v-12M11.804 16.678l-4.015-5.734M12.196 16.678l4.015-5.734"
  }));
};
export default SvgIconLoyalty;